import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { API_ENDPOINTS } from "../config/constants";
import { toast } from "react-hot-toast";

const LikeButton = ({
  vehicleId,
  user,
  initialLiked = false,
  initialCount = 0,
  size = "md",
}) => {
  const [liked, setLiked] = useState(initialLiked);
  const [likesCount, setLikesCount] = useState(initialCount);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const fetchLikeStatus = async () => {
      try {
        const res = await fetch(`${API_ENDPOINTS.VEHICLES}/${vehicleId}/like`, {
          credentials: "include",
        });
        const data = await res.json();
        setLiked(data.liked);
        setLikesCount(data.likesCount);
      } catch (err) {
        console.error("Error fetching like status:", err);
      }
    };

    fetchLikeStatus();
  }, [vehicleId]);

  const handleLike = async () => {
    if (!user) {
      toast.error("Please log in to like vehicles");
      return;
    }

    try {
      setIsAnimating(true);
      const res = await fetch(`${API_ENDPOINTS.VEHICLES}/${vehicleId}/like`, {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();
      setLiked(data.liked);
      setLikesCount(data.likesCount);
    } catch (err) {
      console.error("Error toggling like:", err);
      toast.error("Failed to update like status");
    } finally {
      setTimeout(() => setIsAnimating(false), 300);
    }
  };

  return (
    <button
      onClick={handleLike}
      className={`group relative flex items-center gap-1.5 px-2.5 py-1 rounded-full transition-all overflow-hidden ${
        liked
          ? "bg-gradient-to-r from-red-50 to-red-100 text-red-500 hover:from-red-100 hover:to-red-200 shadow-sm hover:shadow-md dark:from-red-900 dark:to-red-800 dark:text-red-500 dark:hover:from-red-800 dark:hover:to-red-700"
          : "bg-gradient-to-r from-primary-50 to-primary-100 text-primary-500 hover:from-primary-100 hover:to-primary-200 shadow-sm hover:shadow-md dark:from-primary-900 dark:to-primary-800 dark:text-primary-500 dark:hover:from-primary-800 dark:hover:to-primary-700"
      } ${!user && "opacity-50 cursor-not-allowed"}`}
      disabled={!user}
    >
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer" />

      <div
        className={`transform transition-all duration-300 ${
          isAnimating ? "scale-125" : "scale-100"
        }`}
      >
        <FontAwesomeIcon
          icon={liked ? faHeartSolid : faHeartRegular}
          className={`${
            size === "sm" ? "w-3.5 h-3.5" : "w-5 h-5"
          } transition-colors mt-[2px]`}
        />
      </div>
      <span
        className={`${
          size === "sm" ? "text-xs font-medium" : "text-sm font-medium"
        }`}
      >
        {likesCount}
      </span>
    </button>
  );
};

export default LikeButton;
